import { pluralizer } from './pluralizer';

export const appendGuestCountLabel = (guestCount: number): string =>
  pluralizer('guest', guestCount);
